import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-edit-society-cof',
  templateUrl: './edit-society-cof.component.html',
  styleUrls: ['./edit-society-cof.component.css']
})
export class EditSocietyCofComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
